import React from "react";
import Lottie from "lottie-react";
import truckAnimation from "./Truck.json"; // Adjust the path

const CommonLoader = () => {
  return (
    <div style={{ width: 300, height: 300 }}>
      {" "}
      {/* Adjust size as needed */}
      <Lottie animationData={truckAnimation} loop={true} />
    </div>
  );
};

export default CommonLoader;
